import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/destination.css';

export default class Alappuzha extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview'
    };
  }

  render() {
    const attractions = [
      {
        name: "Alleppey Backwaters",
        image: "/assets/img/alleppey-backwaters.jpg",
        description: "The backwaters of Alleppey are the most popular tourist attraction in Kerala. A network of interconnected canals, rivers, lakes and lagoons forming a 900 km long waterway.",
        highlight: "Venice of the East",
        bestTime: "Nov-Feb",
        duration: "Full Day"
      },
      {
        name: "Houseboat Cruise",
        image: "/assets/img/houseboat.jpg",
        description: "Experience the iconic Kerala houseboats (Kettuvallams) with traditional architecture, modern amenities, and authentic Kerala cuisine prepared onboard.",
        highlight: "Luxury Stay on Water",
        bestTime: "Oct-Mar",
        duration: "1-2 Nights"
      },
      {
        name: "Alleppey Beach",
        image: "/assets/img/alleppey-beach.jpg",
        description: "A beautiful beach with a 137-year-old pier extending into the sea. Perfect for evening walks, sunset views, and relaxing by the Arabian Sea.",
        highlight: "Sunset Paradise",
        bestTime: "Evenings",
        duration: "2-3 Hours"
      },
      {
        name: "Kuttanad Region",
        image: "/assets/img/kuttanad.jpg",
        description: "Known as the 'Rice Bowl of Kerala', this region features lush paddy fields below sea level, offering unique agricultural landscapes and village life experiences.",
        highlight: "Below Sea Level Farming",
        bestTime: "Aug-Mar",
        duration: "Half Day"
      },
      {
        name: "Alappuzha Lighthouse",
        image: "/assets/img/lighthouse.png",
        description: "An ancient lighthouse built in 1862, offering panoramic views of the Arabian Sea and the backwaters. Climb 150 steps for breathtaking views.",
        highlight: "Historic Landmark",
        bestTime: "Morning/Evening",
        duration: "1 Hour"
      },
      {
        name: "Vembanad Lake",
        image: "/assets/img/vembanad.jpg",
        description: "The longest lake in India and the largest in Kerala. Host to the famous Nehru Trophy Boat Race and numerous migratory birds.",
        highlight: "Boat Race Venue",
        bestTime: "Aug-Sep",
        duration: "2-3 Hours"
      },
      {
        name: "Pathiramanal Island",
        image: "/assets/img/pathiramanal.jpg",
        description: "A beautiful small island in Vembanad Lake, accessible only by boat. A haven for bird watchers with over 80 species of migratory birds.",
        highlight: "Bird Watcher's Paradise",
        bestTime: "Nov-Feb",
        duration: "2-3 Hours"
      },
      {
        name: "Revi Karunakaran Museum",
        image: "/assets/img/museum.jpeg",
        description: "A private museum showcasing exquisite collections of Swarovski crystal, porcelain, ivory, and artifacts from around the world.",
        highlight: "Art & Antiques",
        bestTime: "All Year",
        duration: "2 Hours"
      }
    ];

    const experiences = [
      {
        title: "Houseboat Stay",
        description: "Overnight cruise through backwaters with traditional Kerala cuisine",
        icon: "fas fa-ship"
      },
      {
        title: "Shikara Ride",
        description: "Small boat tours through narrow canals and village life exploration",
        icon: "fas fa-water"
      },
      {
        title: "Kayaking",
        description: "Adventure kayaking through serene backwater channels",
        icon: "fas fa-sailboat"
      },
      {
        title: "Village Walk",
        description: "Guided tours through local villages and coir-making demonstrations",
        icon: "fas fa-walking"
      }
    ];

    const quickInfo = [
      { label: "Location", value: "Alappuzha District, Kerala", icon: "fas fa-map-marker-alt" },
      { label: "Best Time to Visit", value: "October to February", icon: "fas fa-calendar-alt" },
      { label: "Nearest Airport", value: "Cochin International Airport (85 km)", icon: "fas fa-plane" },
      { label: "Nearest Railway", value: "Alappuzha Railway Station (2 km)", icon: "fas fa-train" },
      { label: "Famous For", value: "Backwaters, Houseboats, Boat Race", icon: "fas fa-leaf" },
      { label: "Language", value: "Malayalam, English, Hindi", icon: "fas fa-language" }
    ];

    const festivals = [
      {
        name: "Nehru Trophy Boat Race",
        month: "August",
        description: "The most famous snake boat race held on Vembanad Lake every year"
      },
      {
        name: "Alappuzha Beach Festival",
        month: "December-January",
        description: "Cultural programs, water sports, and food festival at the beach"
      },
      {
        name: "Kuttanad Harvest Festival",
        month: "January",
        description: "Celebration of harvest season with traditional music and dance"
      }
    ];

    return (
      <div className="dest-destination-page">
        {/* Hero Section */}
        <div className="destination-hero">
          <div className="dest-hero-overlay"></div>
          <div className="dest-hero-background">
            <img src="/assets/img/alappuzha-hero.png" alt="Alleppey Backwaters" />
          </div>
          <div className="dest-hero-content">
            <div className="dest-hero-badge">
              <span>Venice of the East</span>
            </div>
            <h1 className="dest-hero-title">Alappuzha</h1>
            <p className="dest-hero-subtitle">
              Where backwaters weave dreams and houseboats float on tranquility
            </p>
            <div className="dest-hero-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>Alappuzha District, Kerala, India</span>
            </div>
          </div>
          <div className="dest-hero-scroll">
            <span>Scroll to explore</span>
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="dest-intro-section">
          <Grid>
            <Row>
              <Col xs={12} md={7} className="dest-intro-text">
                <h2 className="dest-section-title">Welcome to Alleppey</h2>
                <p className="dest-intro-description">
                  Often referred to as the "Venice of the East", Alappuzha is a picturesque district 
                  in Kerala known for its serene backwaters, lush paddy fields, and tranquil beaches. 
                  The city is crisscrossed by a network of canals, rivers, and lagoons that form part 
                  of the famous Kerala backwaters.
                </p>
                <p className="dest-intro-description">
                  Alappuzha is synonymous with houseboat cruises, offering visitors a unique opportunity 
                  to experience the region's beauty while gliding through palm-fringed waterways. The 
                  district is also famous for the annual Nehru Trophy Boat Race, a spectacular event 
                  that draws thousands of spectators.
                </p>
                <div className="dest-highlight-box">
                  <i className="fas fa-star"></i>
                  <span>Did You Know? Alappuzha's backwaters cover nearly 900 km of interconnected waterways, making it one of the largest backwater networks in the world.</span>
                </div>
              </Col>
              <Col xs={12} md={5} className="dest-quick-info">
                <h3>Quick Facts</h3>
                <div className="dest-info-grid">
                  {quickInfo.map((info, index) => (
                    <div key={index} className="dest-info-card">
                      <div className="dest-info-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="dest-info-content">
                        <span className="dest-info-label">{info.label}</span>
                        <span className="dest-info-value">{info.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Experiences Section */}
        <div className="dest-experiences-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Experiences in Alleppey</h2>
            <p className="dest-section-subtitle">
              Unique ways to explore the beauty of backwaters
            </p>
          </div>
          <Grid>
            <Row className="experiences-grid">
              {experiences.map((exp, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="experience-col">
                  <div className="experience-card">
                    <div className="exp-icon">
                      <i className={exp.icon}></i>
                    </div>
                    <h4 className="exp-title">{exp.title}</h4>
                    <p className="exp-description">{exp.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Attractions Section */}
        <div className="dest-attractions-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Top Attractions in Alleppey</h2>
            <p className="dest-section-subtitle">
              Discover the most beautiful places that make Alleppey a paradise for nature lovers
            </p>
          </div>

          <Grid>
            <Row className="dest-attractions-grid">
              {attractions.map((attraction, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="dest-attraction-col">
                  <div className="dest-attraction-card">
                    <div className="dest-card-image">
                      <img src={attraction.image} alt={attraction.name} />
                      <div className="dest-card-overlay">
                        <span className="dest-highlight-tag">{attraction.highlight}</span>
                      </div>
                    </div>
                    <div className="dest-card-content">
                      <h3 className="dest-attraction-name">{attraction.name}</h3>
                      <p className="dest-attraction-description">{attraction.description}</p>
                      <div className="dest-card-footer">
                        <div className="dest-time-info">
                          <span className="dest-best-time">
                            <i className="far fa-calendar"></i>
                            {attraction.bestTime}
                          </span>
                          <span className="dest-duration">
                            <i className="far fa-clock"></i>
                            {attraction.duration}
                          </span>
                        </div>
                        <button className="dest-read-more-btn">Read More</button>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Houseboat Experience Section */}
        <div className="houseboat-section">
          <div className="houseboat-overlay"></div>
          <div className="houseboat-bg"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="houseboat-content">
                <div className="houseboat-badge">Iconic Experience</div>
                <h2 className="houseboat-title">Houseboat Experience</h2>
                <p className="houseboat-description">
                  A houseboat cruise through the backwaters of Alleppey is an experience like no other. 
                  These traditional Kettuvallams (houseboats) have been transformed into luxurious floating 
                  accommodations, complete with modern amenities, comfortable bedrooms, and an open deck 
                  to enjoy the scenic beauty.
                </p>
                <p className="houseboat-description">
                  As you glide through palm-fringed canals, you'll witness the daily life of villages along 
                  the waterways, lush paddy fields, and an incredible variety of birds. The onboard chef 
                  prepares delicious authentic Kerala meals, including fresh seafood, making your journey 
                  a culinary delight.
                </p>
                <div className="houseboat-features">
                  <div className="feature">
                    <i className="fas fa-utensils"></i>
                    <span>Traditional Kerala Cuisine</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-bed"></i>
                    <span>AC Deluxe Bedrooms</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-sun"></i>
                    <span>Open Deck with Sun loungers</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-wifi"></i>
                    <span>Modern Amenities</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Boat Race Section */}
        <div className="boatrace-section">
          <Grid>
            <Row>
              <Col xs={12} md={6} className="boatrace-content">
                <div className="boatrace-badge">Spectacular Event</div>
                <h2 className="boatrace-title">Nehru Trophy Boat Race</h2>
                <p className="boatrace-description">
                  Held annually in August on the Punnamada Lake, the Nehru Trophy Boat Race is one of 
                  the most anticipated events in Kerala. Snake boats, known as Chundan Vallams, race 
                  against each other in a spectacular display of teamwork and tradition.
                </p>
                <p className="boatrace-description">
                  The event attracts thousands of spectators from around the world. The rhythmic chanting 
                  of oarsmen, the vibrant colors of the boats, and the electrifying atmosphere make it an 
                  unforgettable experience. Each snake boat can hold up to 100 oarsmen and stretches 
                  over 100 feet in length.
                </p>
                <div className="race-stats">
                  <div className="stat">
                    <span className="number">100+</span>
                    <span className="label">Oarsmen per Boat</span>
                  </div>
                  <div className="stat">
                    <span className="number">100+</span>
                    <span className="label">Feet Long</span>
                  </div>
                  <div className="stat">
                    <span className="number">August</span>
                    <span className="label">Peak Season</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Festivals Section */}
        <div className="festivals-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Festivals & Events</h2>
              <p className="dest-section-subtitle">Celebrate the vibrant culture of Alleppey</p>
            </div>
            <Row className="festivals-grid">
              {festivals.map((festival, index) => (
                <Col xs={12} sm={6} md={4} key={index} className="festival-col">
                  <div className="festival-card">
                    <div className="festival-month">{festival.month}</div>
                    <h3 className="festival-name">{festival.name}</h3>
                    <p className="festival-description">{festival.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Travel Tips Section */}
        <div className="dest-tips-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Travel Tips for Alleppey</h2>
              <p className="dest-section-subtitle">Make the most of your visit to the backwater paradise</p>
            </div>
            <Row className="dest-tips-grid">
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-ship"></i>
                  </div>
                  <h4>Book Houseboat Early</h4>
                  <p>Houseboats get booked quickly during peak season (Nov-Feb). Book at least 2-3 weeks in advance.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-tshirt"></i>
                  </div>
                  <h4>What to Wear</h4>
                  <p>Light cotton clothes, comfortable footwear, and a hat for sun protection. Carry a light jacket for evenings.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-camera"></i>
                  </div>
                  <h4>Capture the Moments</h4>
                  <p>Best photography times are during sunrise and sunset. Don't forget to capture the village life along the canals.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-utensils"></i>
                  </div>
                  <h4>Must Try Foods</h4>
                  <p>Fresh seafood, Kerala sadya, karimeen pollichathu, and toddy (local beverage) at licensed shops.</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* CTA Section */}
        <div className="dest-cta-section">
          <div className="dest-cta-content">
            <h3>Ready to Cruise the Backwaters?</h3>
            <p>Let us help you plan your perfect Alleppey experience</p>
            <Link to="/contact" className="dest-cta-button">
              Book Your Houseboat
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}